import React, { RefObject } from 'react'
import { SearchSVG, CloseIconSVG } from '@/src/ui/AllSVG'

interface SearchBarProps {
    query: string
    inputRef: RefObject<HTMLInputElement | null>
    onChange: (value: string) => void
    onClear: () => void
    onClose: () => void
    onSubmitSearch?: () => void
}

export default function SearchBar({ query, inputRef, onChange, onClear, onClose, onSubmitSearch }: SearchBarProps) {
    return (
        <>

            <div className="flex items-center gap-4 px-4 py-3">
                <span className="shrink-0">
                    <SearchSVG />
                </span>
                <input
                    ref={inputRef}
                    type="text"
                    value={query}
                    onChange={(e) => onChange(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault()
                            onSubmitSearch?.()
                        }
                    }}
                    placeholder="Type your search"
                    className="flex-1 bg-transparent outline-none text-sm text-body-color placeholder:text-body-color/40 tracking-wide"
                />
                <div className="flex items-center gap-2 shrink-0">
                    {query && (
                        <button
                            onClick={onClear}
                            className="text-xs text-body-color tracking-widest uppercase transition-colors cursor-pointer"
                        >
                            Clear
                        </button>
                    )}
                    <button
                        onClick={onClose}
                        aria-label="Close search"
                        className="bg-white p-2 rounded-full overflow-hidden shadow-[0_8px_40px_0_rgba(0,0,0,0.12)]"
                    >
                        <CloseIconSVG />
                    </button>
                </div>
            </div>
        </>
    )
}
